export const HEADER_MOBILE_HEIGHT: number = 50;
export const HEADER_DESKTOP_HEIGHT: number = 64;
export const HEADER_MENU_HEIGHT: number = 46;
export const HEADER_SKIP_LINKS_HEIGHT: number = 27;

export const HEADER_DESKTOP_HEIGHT_WITH_MENU =
    HEADER_DESKTOP_HEIGHT + HEADER_MENU_HEIGHT;
export const HEADER_DESKTOP_HEIGHT_WITH_SKIP_LINKS =
    HEADER_DESKTOP_HEIGHT + HEADER_SKIP_LINKS_HEIGHT;
